import {
    LOGIN_ESBORRAR_DADES_USUARI_REGISTRAT,
    LOGIN_OMPLIR_DADES_USUARI_REGISTRAT
} from '../actions/actionTypes';

const ESTAT_INICIAL = {};

const login = (state = ESTAT_INICIAL, action) => {

    switch(action.type) {
        case LOGIN_OMPLIR_DADES_USUARI_REGISTRAT:
            return action.dadesUsuari;

        case LOGIN_ESBORRAR_DADES_USUARI_REGISTRAT:
            return ESTAT_INICIAL;

        default:
            return state;
    }
};

export default login;


// WEBPACK FOOTER //
// ./src/reducers/login.js